<mat-accordion [multi]="false">
  @for (group of menuConfig; track group) {
    @if (isGroupVisible(group)) {
      <mat-expansion-panel class="menu-group">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <img [src]="group.icon" class="group-icon" alt="" />
            <span class="group-label">{{ translate(group.translationKey) }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <nav class="menu-items">
          @for (item of visibleItems(group.items); track item) {
            <a class="menu-item" [routerLink]="item.route" routerLinkActive="active">
              {{ translate(item.translationKey) }}
            </a>
          }
          @for (link of visibleLinks(group.links); track link) {
            <a class="menu-item external" [href]="link.url" target="_blank" rel="noopener">
              {{ translate(link.translationKey) }}
              <mat-icon class="external-icon">open_in_new</mat-icon>
            </a>
          }
        </nav>
      </mat-expansion-panel>
    }
  }
</mat-accordion>
